/**
 * We're using the format of `${lang-iso-code}-${country-iso-code}` as our Iso Code,
 * Check out this, https://www.andiamo.co.uk/resources/iso-language-codes/
 * We will have standard format of it after we decide to support more languages
 */

export const languageList = [
  {
    name: "English",
    iso: "en-us",
    countryIso: 'us',
  },
  {
    name: "Español",
    iso: "es",
    countryIso: 'es',
  },
  {
    name: "Français",
    iso: "fr",
    countryIso: 'fr',
  },
  {
    name: "Deutsch",
    iso: "de",
    countryIso: "de",
  },
  {
    name: "Nederlands",
    iso: "nl",
    countryIso: "nl",
  },
  {
    name: "Arabic",
    iso: "ar",
    countryIso: "sa",
  },

];
